
import React from 'react';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Loader2 } from 'lucide-react';
import { BackendProgressStage } from './enrichmentTypes';

interface EnrichingDialogContentProps {
  clientName: string;
  message?: string; 
  progressStage?: BackendProgressStage | string | null;
  estimatedCompletionTime?: string | null; // New prop
}

export const EnrichingDialogContent: React.FC<EnrichingDialogContentProps> = ({ 
  clientName, 
  message, 
  progressStage,
  estimatedCompletionTime, // Destructure
}) => {
  let displayMessage = message || 'Initiating enrichment, please wait...';

  if (progressStage) {
    switch (progressStage) {
      case 'queued':
        displayMessage = 'Request queued. Preparing to start enrichment...';
        break;
      case 'requested':
        displayMessage = 'Enrichment request received, preparing to initiate...';
        break;
      case 'initiated_lutra':
        displayMessage = 'Connecting with enrichment service...';
        break;
      case 'processing':
        displayMessage = 'Enrichment service is processing...';
        break;
      // This component is typically for initial states, more detailed pending states are in EnrichmentPendingDialogContent
    }
  }

  return (
    <>
      <DialogHeader>
        <DialogTitle>Enriching {clientName}...</DialogTitle>
      </DialogHeader>
      <div className="py-8 flex flex-col items-center justify-center text-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
        <p className="text-muted-foreground">{displayMessage}</p>
        {estimatedCompletionTime && (
          <p className="text-sm text-muted-foreground mt-2">{estimatedCompletionTime}</p>
        )}
      </div>
    </>
  );
};
